// Host-side cache lifetime classification, separate from SDK copy/retry policy.
// Only canonical admission failures retire the document's private material.
// A provider outage, even an HTTP 403 from upstream, is not current authority.
const deniedCodes = new Set([
  'NOT_AUTHORIZED',
  'not_authorized',
  'runtime_access_denied',
  'app_not_authorized',
  'app_version_not_authorized',
  'app_saved_selection_changed',
  'scope_invalidated',
  'view_cache_selection_changed',
  'view_cache_scope_denied',
  'connection_binding_stale',
  'connection_changed',
  'connection_not_found',
  'read_access_denied',
  'read_operation_denied',
  'read_access_stale',
  'company_required',
]);
const sessionErrors = new Set(['SessionChangedError', 'SessionUnverifiedError']);

/** Input is the host's typed failure, never arbitrary provider result material.
 * cacheDenied is a host-private transport marker; no guest input sets it. */
export function isCachedReadDenial(error) {
  if (!error || typeof error !== 'object') return false;
  if (error.cacheDenied === true || sessionErrors.has(error.name)) return true;
  if (['connection_unavailable', 'resource_connection_unavailable'].includes(error.code))
    return error.statusCode === 403 || error.statusCode === 409;
  return deniedCodes.has(error.code);
}
